var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 1 34 33",
    preserveAspectRatio: "xMidYMid meet",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.616,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.197 6.831c1.958-2.694 4.398-4.041 7.318-4.041 4.381 0 7.323 2.48 8.296 6.1.973 3.62-.275 7.175-3.915 10.86-2.426 2.458-6.331 6.582-11.715 12.373m-.1 0c-5.384-5.791-9.288-9.915-11.715-12.373C.726 16.065-.522 12.51.451 8.89c.972-3.62 3.915-6.1 8.296-6.1 2.92 0 5.36 1.347 7.318 4.041h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.068 11.148l5.172 9.814 5.173-9.814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegon);
export default __webpack_public_path__ + "static/media/vegon.dfd2654e57aef0317257900ee770d7d9.svg";
export { ForwardRef as ReactComponent };